'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SunIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.9964 19.2489V22M11.9964 1.98851V4.74241M4.74675 11.9956H2M22.0042 11.9956H19.246M6.86786 17.1242L4.9211 19.0709M19.0727 4.9193L17.1248 6.86717M6.8679 6.86714L4.92291 4.92216M19.0717 19.0709L17.1249 17.1242M16.75 12C16.75 14.6234 14.6234 16.75 12 16.75C9.37665 16.75 7.25 14.6234 7.25 12C7.25 9.37665 9.37665 7.25 12 7.25C14.6234 7.25 16.75 9.37665 16.75 12Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpSunIcon = forwardRef(SunIcon);

export { VpSunIcon as default };
